import { QuizDiagnosticsTagColor } from '../types'

import quizDiagnosticsColorPalette from './quizDiagnosticsColorPalette.json'

export type QuizDiagnosticsPaletteColorKey = keyof typeof quizDiagnosticsColorPalette

export type QuizDiagnosticsPaletteVariant =
  | 'stroke'
  | 'book'
  | 'chapter'
  | 'section'

const isPaletteColorKey = (
  color: QuizDiagnosticsTagColor
): color is QuizDiagnosticsPaletteColorKey => color in quizDiagnosticsColorPalette

export const getQuizDiagnosticsPaletteColor = (
  color: QuizDiagnosticsTagColor,
  variant: QuizDiagnosticsPaletteVariant
): string | undefined => {
  if (!isPaletteColorKey(color)) {
    return undefined
  }

  return quizDiagnosticsColorPalette[color][variant]
}
